import Api from '@/services/Api'
import LocalStorage from '@/services/LocalStorageService'

const root = 'emailserver'
const clientRoot = () => `${LocalStorage.getClientPrefix()}/emailserver`

class EmailServerService {
  about () {
    return Api().get(`${clientRoot()}/about`)
  }

  insert (item) {
    return Api().post(root, item)
  }

  update (item) {
    return Api().put(root, item)
  }

  findAll () {
    return Api().get(clientRoot())
  }

  findAllIdentifiers () {
    return Api().get(`${clientRoot()}/identifiers`)
  }

  delete ({ serverName }) {
    return Api().delete(`${clientRoot()}/${serverName}`)
  }

  findById (id) {
    return Api().get(`${clientRoot()}/${id}`)
  }

  notificationServers () {
    return Api().get(`${clientRoot()}/notificationServers`)
  }
}

export default new EmailServerService()
